*,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

:host(.wui-spinner-overlay) {
  display: contents;
}

.wui-spinner {
  position: relative;
  width: var(--wui-spinner-size, 24px);
  height: var(--wui-spinner-size, 24px);
  color: #666;

  span {
    position: absolute;
    top: 0;
    left: 50%;
    transform-origin: center center;

    width: 10%;
    height: 100%;

    animation: wui-spinner-leaf-fade 0.8s linear infinite;

    &::before {
      content: '';

      display: block;

      width: 100%;
      height: 30%;
      margin-top: 12%;
      border-radius: calc(infinity * 1px);

      background-color: currentcolor;
    }
  }
}

.wui-spinner-overlay {
  pointer-events: none;

  position: fixed;
  z-index: var(--wui-layer-loading, 300);
  inset: 0;

  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;

  .wui-spinner {
    pointer-events: auto;
  }
}

.spinner-description {
  pointer-events: auto;

  max-width: 240px;

  font-size: var(--wui-font-size, 14px);
  line-height: 1.5;
  color: var(--wui-color-text-secondary, #6a6a6a);
  text-align: center;
}

@keyframes wui-spinner-leaf-fade {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}
